import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProgressSpinnerService
{
    // Private
    private _bufferValueSpinner: BehaviorSubject<number>;
    private _modeSpinner: BehaviorSubject<string>;
    private _valueSpinner: BehaviorSubject<number>;
    private _visibleSpinner: BehaviorSubject<boolean>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router
    )
    {
        // Initialize the service
        this._init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Buffer value
     */
    get bufferValue(): Observable<any>
    {
        return this._bufferValueSpinner.asObservable();
    }

    setBufferValue(value: number): void
    {
        this._bufferValueSpinner.next(value);
    }

    /**
     * Mode
     */
    get mode(): Observable<any>
    {
        return this._modeSpinner.asObservable();
    }

    setMode(value: 'determinate' | 'indeterminate' | 'buffer' | 'query'): void
    {
        this._modeSpinner.next(value);
    }

    /**
     * Value
     */
    get value(): Observable<any>
    {
        return this._valueSpinner.asObservable();
    }

    setValue(value: number): void
    {
        this._valueSpinner.next(value);
    }

    /**
     * Visible
     */
    get visible(): Observable<any>
    {
        return this._visibleSpinner.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void
    {
        // Initialize the behavior subjects
        this._bufferValueSpinner = new BehaviorSubject(0);
        this._modeSpinner = new BehaviorSubject('indeterminate');
        this._valueSpinner = new BehaviorSubject(0);
        this._visibleSpinner = new BehaviorSubject(false);

        // Subscribe to the router events to show/hide the loading bar
        /*this._router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
                this.show();
            });

        this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel))
            .subscribe(() => {
                this.hide();
            });
        */
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the progress spinner
     */
    show(): void
    {
        this._visibleSpinner.next(true);
    }

    /**
     * Hide the progress spinner
     */
    hide(): void
    {
        this._visibleSpinner.next(false);
    }
}
